/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from 'yup'

const MandatoryCheckSchema = Yup.object().shape({
  mandatoryCheck: Yup.string()
    .max(100, 'Must not exceed 100 characters')
    .test({
      name: 'required',
      test: (value: any, testContext: any) => {
        let message = 'Required'
        if (testContext.parent.mandatoryCheckDetails) {
          if (!testContext.parent.mandatoryCheckDetails.FIELD_REQ) return true

          message = `${
            testContext?.parent?.mandatoryCheckDetails?.FIELD_LABEL ??
            'Mandatory check info'
          } is required.`
        }

        if (value !== undefined && value !== null) return true
        return testContext.createError({
          message,
          path: testContext.path,
        })
      },
    }),
})

export default MandatoryCheckSchema
